import PropTypes from "prop-types"
import React, { useEffect } from "react"
import axios from "axios"
import { Switch, BrowserRouter as Router } from "react-router-dom"
import { connect } from "react-redux"

// Import Routes all
import { userRoutes, authRoutes } from "./routes/allRoutes"

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"
import { authService } from "services/auth.service"
import jwt_decode from "jwt-decode"
// Import scss
import "./assets/scss/theme.scss"

const App = props => {
  axios.interceptors.request.use(
    config => {
      const { origin } = new URL(config.url)
      const allowedOrigins = [
        "http://10.10.10.123:3040",
        "http://192.168.10.37:3040",
        "https://auth.upoint.mn",
        "https://astral.upoint.mn",
        "https://api.astral.upoint.mn",
        "http://localhost:3040",
      ]

      const token = authService.accessToken

      if (config.url !== "https://auth.upoint.mn/internal/login") {
        try {
          var decoded = jwt_decode(token)
          if (Date.now() >= decoded.exp * 1000) {
            authService.logout()
            window.location.href = "/login"
          }
        } catch (err) {
          console.log(err, "error")
        }
      }
      if (allowedOrigins.includes(origin)) {
        config.headers.authorization = `Bearer ${token}`
      }
      return config
    },
    error => {
      console.log(error, "error")
      return Promise.reject(error)
    }
  )
  function getLayout() {
    let layoutCls = VerticalLayout
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout
        break
      default:
        layoutCls = VerticalLayout
        break
    }
    return layoutCls
  }

  const Layout = getLayout()
  return (
    <React.Fragment>
      <Router>
        <Switch>
          {authRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
              exact
            />
          ))}

          {userRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
              exact
            />
          ))}
        </Switch>
      </Router>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)
